import { useContext } from 'react';

import { PusherContextValues } from './types';
import { PusherContext } from './PusherProvider';

export function usePusher() {
  return useContext<PusherContextValues>(PusherContext);
}
